module.exports = __webpack_public_path__ + "img/TR.cf31c9d6.svg";